<template>
    <OverlayLoader :isLoading="false">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('general.dashboard')"
                />

                <p class="subtitle">Shortcuts</p>

                <div class="col-sm-12 client-shortcuts" style="padding-left:0px;">
                    <div class="route-item" v-for="(item, index) in routes" :key="`${item.name}-${index}`" @click="$router.push({ name: item.name })">
                        <i class="fal fa-plus pointer"></i>
                        <span>{{item.label}}</span>
                    </div>

                </div>

                <div class="col-sm-12" style="display:flex; padding:0px; margin-top:16px;">
                    <div class="col-sm-7" style="padding:0px;">
                        <p class="subtitle">{{ t('client.attention.needed') }}</p>

                        <Attention
                            :attentionItems="attentionItems"
                        >
                        </Attention>
                    </div>
                    <div class="col-sm-5" >
                        <p class="subtitle">{{ t('general.connections') }}</p>
                        <WhiteTable :labels="[$translate.text('general.name')]">
                            <template slot="table-data">
                                <tr v-for="connection in connections" :key="connection.id">
                                    <td>{{ connection.name }}</td>
                                    <td class="align-right">
                                        <i class="fal fa-external-link-square" @click="$router.push({ name: 'Clients Connections Edit', params: { id: connection.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                    </td>

                                </tr>
                                <tr v-if="!connections.length">
                                    <td colspan="4">{{ t('general.no_results_found') }}</td>
                                </tr>
                            </template>
                        </WhiteTable>
                    </div>

                </div>

                <AccountSubscriptionInformation></AccountSubscriptionInformation>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import Attention from '@/components/Client/Attention';
import AccountSubscriptionInformation from '@/components/Account/AccountSubscriptionInformation';
import { get } from '@/helpers/http';
import handleError from '@/helpers/error';

export default {
    name: 'ClientsDashboard',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
        Attention,
        AccountSubscriptionInformation,
    },

    data() {
        return {
            routes: [
                { name: 'Clients Webshops Add', label: this.$translate.text('clients.webshops.add') },
                { name: 'Clients Feeds Add', label: this.$translate.text('clients.feeds.add') },
                { name: 'Clients Connections Add', label: this.$translate.text('clients.connections.add') },
            ],

            attentionItems: [],
            attentionItemsLoaded: false,

            connections: [],
            connectionsLoaded: false,
        };
    },

    created() {
        this.getConnections();
        this.getAttentions();
    },

    methods: {
        getConnections() {
            get({
                url: `${this.$API_URL}/api/clients/connections`,
            })
                .then((response) => {
                    const connections = response.data.data;
                    connections.forEach(item => {
                        item.status = 'Pending';
                        item.sync = '100/500';
                    });
                    this.connections = connections;
                    this.connectionsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getAttentions() {
            get({
                url: `${this.$API_URL}/api/clients/attention`,
            })
                .then((response) => {
                    const connections = response.data.data;
                    this.attentionItems = connections;
                    this.attentionItemsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.client-shortcuts {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr;

    .route-item {
        background-color: white;
        padding: 8px;
        border-radius: 5px;
        margin-left: 8px;
        margin-right: 8px;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
            background-color:#CBD5E0;
        }

        span {
            padding-left:10px;
        }
    }

    .route-item:first-child {
        margin-left: 0px;
    }

    .route-item:last-child {
        margin-right: 0px;
    }
}

.subtitle {
    margin-bottom: 16px;
    font-size: 20px;
}

.white-table {
    width: 100%;
    position: relative;
}
</style>
